module.exports = __webpack_public_path__ + "img/pyth.18d7eea9.png";